import { CollectUsedImagesResult } from '@website-builder/application/media/model/collect-used-images-result.interface';
import { ImagesMapValue } from '@website-builder/application/media/model/images-map-value.interface';

const IMAGE_KEY_RE = /Images\/Users\/\d+\/(?:Thumbnails\/)?[a-f0-9]{64}/gi;

export function extractCandidatesFromString(s: string): string[] {
  if (!s.includes('Images/Users/')) {
    return [];
  }

  const matches = s.match(IMAGE_KEY_RE);

  if (!matches?.length) {
    return [];
  }

  return matches.map(m => m.replace(/\/Thumbnails\//i, '/'));
}

export function collectUsedImages(root: unknown, imagesMap: Map<string, ImagesMapValue>): CollectUsedImagesResult {
  const knownKeys = new Set(imagesMap.keys());
  const usedKeys = new Set<string>();
  const unknownCandidates = new Set<string>();

  const visited = new WeakSet<object>();

  const stack: unknown[] = [root];

  while (stack.length) {
    const current = stack.pop();

    if (current === null) {
      continue;
    }

    const type = typeof current;

    if (type === 'string') {
      const currentString = current as string;

      if (knownKeys.has(currentString)) {
        usedKeys.add(currentString);

        continue;
      }

      const candidates = extractCandidatesFromString(currentString);

      for (const candidate of candidates) {
        if (knownKeys.has(candidate)) {
          usedKeys.add(candidate);
        } else {
          unknownCandidates.add(candidate);
        }
      }

      continue;
    }

    if (type !== 'object') {
      continue;
    }

    const currentObject = current as object;

    if (visited.has(currentObject)) {
      continue;
    }

    visited.add(currentObject);

    if (Array.isArray(current)) {
      for (const item of current) {
        stack.push(item);
      }
    } else {
      for (const v of Object.values(current as Record<string, unknown>)) {
        stack.push(v);
      }
    }
  }

  const usedKeysArr = Array.from(usedKeys);

  const usedIdsArr = usedKeysArr
    .map(usedKey => imagesMap.get(usedKey)?.id)
    .filter((usedKey): usedKey is number => typeof usedKey === 'number');

  return {
    usedKeys: usedKeysArr,
    usedIds: usedIdsArr,
    unknownKeyCandidates: Array.from(unknownCandidates),
  };
}
